import { FeatureName } from './index';

export default [
  'admin.business-entity-view',
  'deckmapp',
  'fleet.claims',
  'fleet.equipment-timezone',
] as const;

export const labels: Record<FeatureName, string> = {
  'admin.business-entity-view': 'Admin delivery points',
  deckmapp: 'DeckMapp',
  'fleet.claims': 'Warranty claims',
  'fleet.equipment-timezone': 'Equipment local time',
};
